export const IS_AR = true;
export const IS_RTL = true;
export const LANG_CODE = 'ar';
export const LANG_DIR = 'rtl';
export const ALTER_LANG_NAME = 'English';
export const ALTER_LANG_CODE = 'en';
export const FOSOL = 'فصول';
export const TAG_LINE = 'أفضل وسيلة للتواصل ما بين الطالب والمعلم';
export const LOG_IN = 'تسجيل دخول';
export const PHONE = 'الجوال';
export const EMAIL = 'الإيميل';
export const PHONE_PH = 'مثال: 555333000';
export const EMAIL_PH = 'مثال: ali@example.com ';
export const USE_EMAIL = 'استخدم البريد الالكتروني للتسجبل‫.‬';
export const USE_PHONE = 'استخدم رقم الجوال للتسجبل.';
export const NEXT = 'التالي';
export const VERIFICATION_SENT = 'لقد تم ارسال رمز التحقق من الهوية إلى';
export const VERIFY = 'التحقق';
export const SAVE = 'حفظ';
export const SEND = 'إرسال';
export const RESEND = 'إعادة إرسال';
export const CODE = 'الرمز';
export const NAME = 'الإسم';
export const FULL_NAME = 'الاسم الكامل';
export const FULL_NAME_PH = 'مثال: محمد العنزي';
export const BACK = 'عودة';
export const OK = 'موافق';



// WEBPACK FOOTER //
// ./src/lang/ar/nologin.js